(() => {
  'use strict';
  const root = document.querySelector('[data-orbes-pdp]');
  if (!root) return;

  const I18N = window.CELESTIAR_I18N || {};
  const LOCALE = I18N.locale === 'en' ? 'en-GB' : 'fr-FR';
  const STORE_KEY = 'celestiar_orbes_form';
  const form = root.querySelector('#OrbesForm');
  const parse = (sel) => { try { return JSON.parse((root.querySelector(sel) || {}).textContent || 'null'); } catch (e) { return null; } };
  const cfg = parse('[data-orbes-config]');
  if (!form || !cfg) return;
  let variants = parse('[data-variants-json]') || [];
  const selected = parse('[data-selected-variant-json]');
  let version = cfg.current;
  let pearl = cfg.pearls[version];
  const FRAMES = ['noir', 'blanc', 'chene'];
  const RECOMMENDED = { nebora: ['noir', 'blanc'], luneria: ['blanc', 'chene'], aurelis: ['chene', 'noir'] };
  const $ = (sel) => root.querySelector(sel);

  /* ---------- Onglets ---------- */
  const panels = [...root.querySelectorAll('[data-panel]')];
  const tabs = [...root.querySelectorAll('[data-tab]')];
  const showTab = (name) => {
    panels.forEach((p) => p.classList.toggle('is-active', p.dataset.panel === name));
    tabs.forEach((t) => {
      const on = t.dataset.tab === name;
      t.classList.toggle('is-active', on);
      t.setAttribute('aria-selected', on ? 'true' : 'false');
    });
  };
  tabs.forEach((t) => t.addEventListener('click', () => showTab(t.dataset.tab)));
  showTab('live');

  /* ---------- Cadre ---------- */
  const frameOf = (value) => {
    const v = String(value || '').toLowerCase();
    if (/noir|black/.test(v)) return 'noir';
    if (/blanc|white/.test(v)) return 'blanc';
    if (/ch[eê]ne|oak|bois|wood|naturel/.test(v)) return 'chene';
    return null;
  };
  /* mise en situation : meme piece, cadre de la couleur choisie */
  const FRAME_LABEL = { noir: 'noir', blanc: 'blanc', chene: 'ch\u00eane' };
  const updateSituation = () => {
    const el = $('[data-orbes-situation]');
    const s = cfg.assets.situation && cfg.assets.situation[version];
    const frame = root.dataset.frame;
    if (!el || !s || !s.frames[frame]) return;
    el.src = s.frames[frame];
    el.width = s.w; el.height = s.h;
    el.alt = version.toUpperCase() + ' en cadre ' + FRAME_LABEL[frame] + ', exemple de personnalisation \u2014 mise en situation (visuel d\u2019illustration)';
  };
  const setFrame = (frame) => {
    if (!FRAMES.includes(frame)) frame = pearl.frame;
    root.dataset.frame = frame;
    const img = $('[data-orbes-frame-img]');
    if (img && cfg.assets.cadre[frame]) img.src = cfg.assets.cadre[frame];
    updateSituation();
  };

  /* ---------- Variantes ---------- */
  const hiddenVariant = form.querySelector('[data-variant-id]');
  const addButton = form.querySelector('[data-add-to-cart]');
  const addLabel = form.querySelector('[data-add-label]');
  const error = form.querySelector('[data-form-error]');
  const defaultError = error ? error.textContent : '';
  const optionsBox = form.querySelector('[data-orbes-options]');
  const money = (cents) => new Intl.NumberFormat(LOCALE, { style: 'currency', currency: 'EUR', minimumFractionDigits: 2 }).format((Number(cents) || 0) / 100);
  let options = selected && Array.isArray(selected.options) ? [...selected.options] : [];
  let frameIndex = -1;

  const findVariant = () => variants.find((v) => Array.isArray(v.options) && v.options.every((o, i) => o === options[i]));
  const updateVariant = () => {
    if (frameIndex >= 0) setFrame(frameOf(options[frameIndex]));
    const v = findVariant();
    if (!v) { hiddenVariant.value = ''; addButton.disabled = true; if (addLabel) addLabel.textContent = I18N.not_found || 'Combinaison introuvable'; return; }
    hiddenVariant.value = v.id;
    if (v.available === false) { addButton.disabled = true; if (addLabel) addLabel.textContent = I18N.unavailable || 'Indisponible'; return; }
    addButton.disabled = !!form.celestiarInvalid;
    if (addLabel) addLabel.textContent = (I18N.add_to_cart_tpl || 'Ajouter au panier — __PRICE__').replace('__PRICE__', money(v.price));
    if (window.history && window.history.replaceState && v.id) {
      const url = new URL(window.location.href); url.searchParams.set('variant', v.id); window.history.replaceState({}, '', url);
    }
  };

  const markRecommended = () => {
    root.querySelectorAll('[data-option-position]').forEach((group) => {
      const isFrame = Number(group.dataset.optionPosition) - 1 === frameIndex;
      group.querySelectorAll('[data-option-value]').forEach((btn) => {
        const rec = isFrame && (RECOMMENDED[version] || []).includes(frameOf(btn.dataset.optionValue));
        btn.classList.toggle('is-recommended', rec);
        btn.dataset.recommended = rec ? cfg.recommended : '';
      });
    });
  };

  const bindOptions = () => {
    frameIndex = -1;
    root.querySelectorAll('[data-option-position]').forEach((group) => {
      const pos = Number(group.dataset.optionPosition || 1) - 1;
      const legend = group.querySelector('legend');
      const values = [...group.querySelectorAll('[data-option-value]')].map((b) => b.dataset.optionValue);
      if (/cadre|frame/i.test(legend ? legend.textContent : '') || values.some((val) => frameOf(val))) {
        if (frameIndex < 0 && values.every((val) => frameOf(val))) frameIndex = pos;
      }
      group.querySelectorAll('[data-option-value]').forEach((btn) => {
        btn.addEventListener('click', () => {
          options[pos] = btn.dataset.optionValue;
          group.querySelectorAll('[data-option-value]').forEach((b) => b.classList.toggle('active', b === btn));
          updateVariant();
        });
      });
    });
    markRecommended();
  };

  const esc = (s) => String(s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const renderOptions = (product) => {
    const names = (product.options || []).map((o) => (typeof o === 'string' ? o : o.name));
    const first = variants.find((v) => v.available) || variants[0];
    options = first ? [...first.options] : [];
    optionsBox.innerHTML = names.map((name, i) => {
      const vals = [...new Set(variants.map((v) => v.options[i]))];
      return '<fieldset class="card config-card option-group is-visible" data-option-position="' + (i + 1) + '" data-testid="orbes-option-group-' + (i + 1) + '">' +
        '<legend><span>0' + (i + 2) + '</span>' + esc(name) + '</legend><div class="option-values">' +
        vals.map((val) => '<button type="button" class="option-button' + (val === options[i] ? ' active' : '') + '" data-option-value="' + esc(val) + '">' + esc(val) + '</button>').join('') +
        '</div></fieldset>';
    }).join('');
    const num = $('[data-orbes-perso-number]');
    if (num) num.textContent = '0' + (names.length + 2);
    bindOptions();
  };

  const selectFrameOption = (frame) => {
    if (frameIndex < 0) return;
    const group = root.querySelector('[data-option-position="' + (frameIndex + 1) + '"]');
    const btn = group && [...group.querySelectorAll('[data-option-value]')].find((b) => frameOf(b.dataset.optionValue) === frame);
    if (btn) btn.click();
  };

  /* ---------- Aperçu en direct ---------- */
  const fields = { prenom: $('[data-live-field="prenom"]'), date: $('[data-live-field="date"]'), phrase: $('[data-live-field="phrase"]') };
  const titleEl = $('[data-orbes-title]');
  const titleToggle = form.querySelector('[data-orbes-title-toggle]');
  const titleInput = form.querySelector('[data-orbes-title-input]');
  const dateDisplay = form.querySelector('[data-orbes-date-display]');
  const counter = form.querySelector('[data-orbes-counter]');
  const values = { prenom: '', ville: '', date: '', phrase: '' };

  const formatDate = (iso) => {
    if (!iso) return '';
    const d = new Date(iso + 'T12:00:00');
    return Number.isNaN(d.getTime()) ? iso : d.toLocaleDateString(LOCALE, { day: 'numeric', month: 'long', year: 'numeric' });
  };
  const cap = (s) => (s ? s.charAt(0).toUpperCase() + s.slice(1) : s);
  const fitSize = (el, size) => { if (el) el.style.fontSize = size + 'cqw'; };
  const lenOf = (el) => (el ? Math.max(1, el.textContent.trim().length) : 1);
  const render = () => {
    if (fields.prenom) fields.prenom.textContent = values.prenom || pearl.prenom;
    if (fields.date) fields.date.textContent = [values.date || pearl.date, values.ville || pearl.ville].filter(Boolean).join(' · ');
    if (fields.phrase) fields.phrase.textContent = values.phrase || (values.prenom ? '' : pearl.phrase);
    fitSize(fields.prenom, Math.max(9, Math.min(21, 150 / lenOf(fields.prenom))));
    fitSize(fields.date, Math.max(3.4, Math.min(4.9, 190 / lenOf(fields.date))));
    const showTitle = !titleToggle || titleToggle.checked;
    if (titleEl) titleEl.hidden = !showTitle;
    if (titleInput) titleInput.value = showTitle ? 'Oui' : 'Non';
  };
  if (titleToggle) titleToggle.addEventListener('change', () => { render(); showTab('live'); });

  const store = () => {
    try {
      const data = {};
      form.querySelectorAll('[data-orbes-input]').forEach((i) => { data[i.dataset.orbesInput] = i.value; });
      sessionStorage.setItem(STORE_KEY, JSON.stringify(data));
    } catch (e) { /* stockage indisponible */ }
  };
  const onInput = (input, fromRestore) => {
    const key = input.dataset.orbesInput;
    let value = input.value.trim();
    if (key !== 'date') value = cap(value);
    if (key === 'date') { value = formatDate(input.value); if (dateDisplay) dateDisplay.value = value; }
    values[key] = value;
    if (key === 'phrase' && counter) counter.textContent = input.value.length + '/60';
    render();
    if (!fromRestore) { showTab('live'); store(); }
  };
  form.querySelectorAll('[data-orbes-input]').forEach((input) => input.addEventListener('input', () => onInput(input, false)));
  try {
    const saved = JSON.parse(sessionStorage.getItem(STORE_KEY) || 'null');
    if (saved) form.querySelectorAll('[data-orbes-input]').forEach((input) => { const v = saved[input.dataset.orbesInput]; if (v) { input.value = v; onInput(input, true); } });
  } catch (e) { /* ignore */ }

  /* ---------- Changement de perle ---------- */
  const applyPearl = (v) => {
    version = v; pearl = cfg.pearls[v];
    const name = v.toUpperCase();
    root.dataset.version = v;
    const set = (sel, fn) => { const el = $(sel); if (el) fn(el); };
    set('[data-orbes-bg]', (el) => { el.src = cfg.assets.fond[v]; });
    set('[data-orbes-exemple]', (el) => { el.src = cfg.assets.exemple[v]; });
    set('[data-orbes-ambiance]', (el) => { el.src = cfg.assets.ambiance[v]; });
    set('[data-orbes-h1]', (el) => { el.textContent = name; });
    set('[data-orbes-tag]', (el) => { el.textContent = pearl.tag; });
    set('[data-orbes-pitch]', (el) => { el.textContent = pearl.pitch; });
    set('[data-orbes-title-name]', (el) => { el.textContent = name; });
    set('[data-orbes-version-input]', (el) => { el.value = name; });
    if (titleEl) titleEl.textContent = name;
    root.querySelectorAll('[data-pearl]').forEach((a) => {
      const on = a.dataset.pearl === v;
      a.classList.toggle('active', on);
      if (on) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current');
    });
    render();
    updateSituation();
    showTab('live');
  };

  root.querySelectorAll('[data-pearl]').forEach((link) => {
    link.addEventListener('click', (event) => {
      const v = link.dataset.pearl;
      if (v === version) { event.preventDefault(); return; }
      event.preventDefault();
      store();
      const href = link.getAttribute('href');
      fetch(href.split('?')[0] + '.js', { headers: { Accept: 'application/json' } })
        .then((r) => { if (!r.ok) throw new Error(); return r.json(); })
        .then((product) => {
          if (!product || !Array.isArray(product.variants) || !product.variants.length) throw new Error('no product');
          variants = product.variants;
          applyPearl(v);
          renderOptions(product);
          if (frameIndex >= 0) selectFrameOption(pearl.frame); else { setFrame(pearl.frame); updateVariant(); }
          if (window.history && window.history.replaceState) window.history.replaceState({}, '', product.url || href);
        })
        .catch(() => { window.location.href = href; });
    });
  });

  /* ---------- Envoi ---------- */
  form.addEventListener('submit', (event) => {
    if (error) error.hidden = true;
    if (!hiddenVariant.value || addButton.disabled) { event.preventDefault(); if (error) { error.textContent = I18N.combo_error || 'Cette combinaison est indisponible.'; error.hidden = false; } return; }
    if (!form.checkValidity()) { event.preventDefault(); form.reportValidity(); if (error) { error.textContent = defaultError; error.hidden = false; } return; }
    try { sessionStorage.removeItem(STORE_KEY); } catch (e) { /* ignore */ }
    addButton.disabled = true;
    if (addLabel) addLabel.textContent = I18N.adding || 'Ajout au panier…';
    if (window.celestiarToast) window.celestiarToast(I18N.added_to_cart || 'Votre affiche rejoint le panier.');
  });

  const hadVariantParam = new URLSearchParams(window.location.search).has('variant');
  bindOptions();
  if (frameIndex < 0) setFrame(pearl.frame);
  render();
  updateVariant();
  if (frameIndex >= 0 && !hadVariantParam) selectFrameOption(pearl.frame);
})();
